var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.308,269.838h108.99v-137.36C92.844,161.683,53.022,210.945,36.308,269.838z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M366.703,132.478v137.36h108.99C458.976,210.945,419.156,161.683,366.703,132.478z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304.432,62.27h-96.865c-11.465,0-20.757,9.294-20.757,20.757v31.484v155.327h138.378V114.511V83.027 C325.189,71.564,315.894,62.27,304.432,62.27z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491.243,311.351h-7.874H366.703h-20.757h-20.757H186.811h-20.757h-20.757H28.63h-7.874 C9.294,311.351,0,320.645,0,332.108v96.865c0,11.463,9.294,20.757,20.757,20.757h470.486c11.462,0,20.757-9.294,20.757-20.757 v-96.865C512,320.645,502.705,311.351,491.243,311.351z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmet);
export default __webpack_public_path__ + "static/media/helmet.b02d3ca3ff0c805a753c0e05591980dd.svg";
export { ForwardRef as ReactComponent };